export default "__VITE_ASSET__Bafk4EqW__"